// extracted by mini-css-extract-plugin
export var searchHeader = "_71-0";
export var searchHeaderDark = "_71-1";